import { render, staticRenderFns } from "./BlogPostsList.vue?vue&type=template&id=b8c77ea4&"
import script from "./BlogPostsList.vue?vue&type=script&lang=js&"
export * from "./BlogPostsList.vue?vue&type=script&lang=js&"
import style0 from "./BlogPostsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
